import axios from "axios";

export const baseURL = "https://api.lifechart.az/";


const request = axios.create({
  baseURL: baseURL,
  withCredentials: false, 
  headers: {
    'Accept': 'application/json', 
    'Content-Type': 'application/json', 
  },
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
       
    if(error.response.status === 401 && error.config.url !== '/auth/login'){
        localStorage.removeItem('token')
    }
    
    return Promise.reject(error);

  }
);

export default request;



